import { createRoot } from 'react-dom/client';
import { RouteErrorPlain } from './routing/RouteError/plain';

export const renderInitialLoadingError = (error: unknown) => {
    const rootNode = document.getElementById('app-mount');

    if (rootNode) {
        const root = createRoot(rootNode);
        root.render(<RouteErrorPlain error={error} />);
    }
};
